// @ts-check
import moment from "moment";
import { dicomDiccionary } from "../../utils/dicom";

export default class StudyForList {
  /**
   * @param {Object} obj
   * @param {number} obj.ID
   * @param {string} obj.EST_UID
   * @param {string} obj.NOMBRE
   * @param {number} obj.PAS_ID
   * @param {Array<Object>} obj.SERIES
   * @param {string} obj.FECHA
   * @param {string} obj.SEXO
   * @param {string} obj.INFORM
   */
  constructor(obj) {
    this.id = obj.ID;
    this.uuid = obj.EST_UID;
    this.patientName = obj.NOMBRE;
    this.patientId = obj.PAS_ID;
    this.modality = Modalitys(obj.SERIES);
    this.studyDate = obj.FECHA;
    this.patientSex = obj.SEXO;
    this.informs = obj.INFORM;
  }

  /**
   * @returns {string}
   */
  getPatientSex() {
    return this.patientSex;
  }

  /**
   * @returns {string}
   */
  sexColor() {
    if (this.patientSex === "M") {
      return "#3498db";
    }
    if (this.patientSex === "F") {
      return "#ec87bf";
    }
    return "#95a5a6";
  }

  /**
   * @returns {string}
   */
  getPatientName() {
    return this.patientName.replaceAll("^", " ").trim();
  }

  /**
   * @returns {number}
   */
  getPatientId() {
    return this.patientId;
  }

  /**
   * @returns {string}
   */
  getModality() {
    let modality = this.modality[0];
    if (this.modality.length > 1) {
      for (let i = 0; i < this.modality.length; i++) {
        if (this.modality[i] !== "SR" && this.modality[i] !== "OT") {
          modality = this.modality[i];
          break;
        }
      }
    }
    return modality;
  }

  /**
   * @returns {string}
   */
  getModalityText() {
    return dicomDiccionary(this.getModality());
  }

  /**
   * @returns {string}
   */
  getStudyDate() {
    return moment(this.studyDate,"YYYYMMDD").format("DD/MM/YYYY");
  }

  /**
   * @returns {string}
   */
  getUuid() {
    return this.uuid;
  }

  /**
   * @returns {number}
   */
  getId() {
    return this.id;
  }

  /**
   * @returns {boolean}
   */
  hasInforms() {
    return this.informs !== "";
  }

  /**
   * @param {string} filtro
   * @returns {boolean}
   */
  filtrar(filtro) {
    let f = filtro.toLowerCase();
    let p = this.patientName.toLowerCase();
    return p.includes(f);
  }

  /**
   * @param {Array<string>} filtro
   * @returns {boolean}
   */
  filtrarmod(filtro) {
    let f = filtro.map((item) => item.toLowerCase());
    let p = this.getModality().toLowerCase();
    return !f.includes(p);
  }
}

/**
 *
 * @param {Array<any>} arr
 * @returns {Array<string>}
 */
function Modalitys(arr) {
  /**
   * @type {Array<string>}
   */
  let r = [];
  arr.forEach((element) => {
    r.push(element.MODALIDAD);
  });
  return r;
}
